import React from 'react';

const PreLoader = () => {
  return (
    <div className="loading-container">
      <div className="lds-ripple"><div></div><div></div></div>
    </div>
  )
}

const InLinePreLoader = () => {
  return (
    <div className="lds-ripple"><div></div><div></div></div>
  )
}

export {
  PreLoader,
  InLinePreLoader
}
